import { render, staticRenderFns } from "./RentalBookings.vue?vue&type=template&id=0d0c3522&scoped=true&"
import script from "./RentalBookings.vue?vue&type=script&lang=ts&"
export * from "./RentalBookings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c3522",
  null
  
)

export default component.exports